import { render } from "./SocialSection.vue?vue&type=template&id=2c6d92a6&scoped=true"
import script from "./SocialSection.vue?vue&type=script&lang=js"
export * from "./SocialSection.vue?vue&type=script&lang=js"

import "./SocialSection.vue?vue&type=style&index=0&id=2c6d92a6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c6d92a6"]])

export default __exports__